import computeClassName from '../../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'font-normal text-cc-body-small',
});

export default function UserName({userName, className=''}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return <span className={computedClassName}>{userName}</span>;
}
